<template>
  <PublicInvoiceView v-if="isPublicRoute" />
  <LiveStoreProvider v-else>
    <template #loading>
      <div class="ls-loading">Loading…</div>
    </template>
    <AppShell :last-sync="lastSyncAt" />
  </LiveStoreProvider>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { Network } from '@capacitor/network';
import { LiveStoreProvider } from 'vue-livestore';
import AppShell from '@/ui/layout/AppShell.vue';
import PublicInvoiceView from '@/features/invoicing/PublicInvoiceView.vue';
import { lastSyncAt, sync } from '@/features/sync/useDriveSync.js';

// A client viewing an emailed invoice link has no local app data and shouldn't pay the cost of
// an offline-first SQLite database spinning up just to view one invoice.
const route = useRoute();
const isPublicRoute = computed(() => route.name === 'public-invoice');

Network.addListener('networkStatusChange', ({ connected }) => {
  if (connected) sync();
});

onMounted(() => {
  // Relay Google OAuth PKCE code from popup back to opener then close.
  if (!globalThis.opener) return;
  const search = new URLSearchParams(globalThis.location.search);
  if (search.has('code') || search.has('error')) {
    globalThis.opener.postMessage(
      { code: search.get('code'), error: search.get('error'), type: 'google-oauth-pkce' },
      globalThis.location.origin,
    );
    globalThis.close();
  }
});
</script>

<style>
.ls-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100dvh;
  color: var(--muted);
  font-size: var(--text-sm);
}
</style>
